module.exports = __webpack_public_path__ + "static/media/Pin_Gray.d279cb2d.svg";